module.exports = __webpack_public_path__ + "img/nodata.878b053b.svg";